export default __webpack_public_path__ + "static/media/placeholder.33148228.png";